<template>
    <div>
        <Datepicker 
            v-if='this.type == "date"'
            v-model="date" 
            locale='en' 
            :id="this.id"
            :style="'width: 100%; border-radius: 12px;'"
            :format="this.format"
            :placeholder="this.placeholder" 
            autoApply autocomplete="off"
            :maxDate="this.max"
            :minDate="this.min"  
            :enableTimePicker="false"
            :clearable="this.clearable"
            :disabled="this.disabled"
            @update:modelValue="this.setValue"
        >
            <template #input-icon>
                <Icon name="calendar" :active="dataValue ? false : true" class="c16 ml12 mr8"/>
            </template>
            <template #clear-icon="{ clear }">
                <Icon name="close" class="c18 mr12" @click="clear" />
            </template>
        </Datepicker>
        <Datepicker 
            v-else-if='this.type == "time" || this.type == "dateTime"' 
            v-model="date" 
            locale='en'
            :autoApply="this.autoApply"
            :enable-seconds="this.enableSeconds"
            :ignore-time-validation="this.ignoreTimeValidation"
            :format="this.format"
            :id="this.id"
            :style="'width: 100%;'"
            :maxDate="this.max"
            :minDate='this.min' 
            :clearable="this.clearable"
            @update:modelValue="this.setValue" 
            :disabled="this.disabled"
        >
            <template #input-icon>
                <Icon name="calendar" :active="dataValue ? false : true" class="c16 ml12 mr8"/>
            </template>
            <template #clear-icon="{ clear }">
                <Icon name="close" class="c18 mr12" @click="clear" />
            </template>
        </Datepicker>
        <Datepicker v-else-if='this.type == "range"' 
            v-model="date"
            :enable-seconds="this.enableSeconds"
            :autoApply="this.autoApply"
            :ignore-time-validation="this.ignoreTimeValidation"
            :format="this.format"
            :id="this.id"
            :maxDate="this.max"
            :minDate='this.min' 
            :enable-time-picker="false"
            :presetDates="presetDates"
            :range="true"
            :clearable="this.clearable"
            @update:modelValue="this.setValue" 
            :disabled="this.disabled"
        >
            <template #preset-date-range-button="{ label, value, presetDate }">
                <span 
                    role="button"
                    :tabindex="0"
                    @click="presetDate(value)"
                    @keyup.enter.prevent="presetDate(value)"
                    @keyup.space.prevent="presetDate(value)">
                {{ label }}
                </span>
            </template>
            <template #input-icon>
                <Icon name="calendar" :active="dataValue ? false : true" class="c16 ml12 mr8"/>
            </template>
            <template #clear-icon="{ clear }">
                <Icon name="close" class="c18 mr12" @click="clear" />
            </template>
        </Datepicker>
        <input :ref="'inph'" type="hidden" :id="id + '_inph'" value="1549312452000" v-on:change="this.forceChange"/>
    </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {ref} from 'vue';
import Icon from '@/components/icons/Icon.vue';

export default {
    components: {
        Datepicker,
        Icon,
    },
    props: {
        id: [String, Boolean],
        dataValue: [String, Boolean, Array],
        type: {
            default: 'date',
            type: [String, Boolean]
        },
        min: {
            default: new Date('1900'),
            type: [Date, Boolean, String]
        },
        max: {
            default: new Date('2100'),
            type: [Date, Boolean, String]
        },
        placeholder: {
            default: '',
            type: [String, Boolean]
        },
        expFormat: { 
            default: false,
            type: [Boolean]
        },
        clearable: {
            default: false,
            type: [Boolean]
        },
        newDate: {
            default: false,
            type: [Boolean]
        },
        disabled: [Boolean],
        enableSeconds: {
            default: false,
            type: [Boolean]
        },
        autoApply: {
            default: true,
            type: [Boolean]
        },
        ignoreTimeValidation: {
            default: false,
            type: [Boolean]
        },
        defaultValue: {
            default: false,
            type: [Boolean, Array]
        }
    },
    watch: {
        dataValue(newd, oldd) {
            if (this.type === 'range') {
                if (Array.isArray(newd) && newd.length === 2) {
                    this.date = [new Date(newd[0]), new Date(newd[1])]
                }
            } else {
                if (newd != false) {
                    this.date = new Date(newd)
                }
            }
        }
    },
    data() {
        return {
            presetDates: [
                { label: this.$t('views.History.44'), value: [new Date(), new Date()] },
                { label: this.$t('views.History.45'), value: [new Date().setDate(new Date().getDate() - 1), new Date().setDate(new Date().getDate() - 1)] },
                { label: this.$t('views.History.46'), value: [new Date().setDate(new Date().getDate() - 7), new Date()] },
                { label: this.$t('views.History.47'), value: [new Date().setMonth(new Date().getMonth() - 1), new Date()] },
                { label: this.$t('views.History.48'), value: [new Date().setYear(new Date().getFullYear() - 1), new Date()] },
            ],
        }
    },
    setup(props) {
        let date;
        let format = 'dd.MM.yyyy';

        if (props.type == 'date') {
            date = props.dataValue ? ref(new Date(props.dataValue)) : ref(new Date);

        //     format = (date) => {
        //         let day = date.getDate();
        //         let month = date.getMonth() + 1;
        //         let year = date.getFullYear();

        //         return `${day}.${month}.${year}`;
        //     }
        }
        if (props.type == 'time') {
            date = ref(new Date);
            format = 'HH:mm';
        }
        if (props.type == 'dateTime') {
            date = props.dataValue ? ref(new Date(props.dataValue)) : ref(new Date);
            format = 'yyyy.MM.dd HH:mm';
        }

        if (props.enableSeconds && props.type == 'dateTime') {
            format = 'MM/dd/yyyy HH:mm:ss';
        }
        if(props.type == 'range') {
            if (Array.isArray(props.dataValue) && props.dataValue.length === 2) {
                date = ref([
                    props.dataValue[0] ? new Date(props.dataValue[0]) : new Date(), 
                    props.dataValue[1] ? new Date(props.dataValue[1]) : new Date()
                ])
            } else {
                date = ref([new Date(), new Date()])
            }
            format = 'dd.MM.yyyy';
        }
        // console.log(props.dataValue)
        return {
            format,
            date
        }
    },
    mounted() {
        this.setValue();
        console.log('mounted inputDateSimple', this.dataValue);
    },
    methods: {
        forceChange() {
            this.date = new Date(Number(this.$refs.inph.value));
            console.log(this.date);
            console.log(this.$refs.inph.value);
            this.setValue();
        },
        setValue() {
            let t = ''
            if ((this.type == 'time')) {
                t = new Date();
                t.setHours(this.date.hours, this.date.minutes);
            } else if ((this.type == 'dateTime')) {
                t = this.date ? this.date.toISOString().split('.')[0].replace(/T/gi, ' ') : false; 
            } else if(this.type == 'range') {
                // Если дата очищена и есть defaultValue, используем его
                if (!this.date && this.defaultValue) {
                    t = this.defaultValue;
                } else {
                    t = this.date ? [this.date[0].toISOString().split('T')[0], this.date[1].toISOString().split('T')[0]] : false;
                }
            } else {
                if (this.expFormat) {
                    t = this.date ? this.date : false;
                } else {
                    t = this.date ? this.date.toISOString().split('T')[0] : false;
                }
            }
            console.log('input date simple', t);
            this.$emit('updateParentState', {
                id: this.id,
                value: t
            })
        }
    },

}
</script>

<style lang="scss">
.inval {
    input  {
        border-color: #dc3545;
        padding-right: calc(1.5em + 0.75rem);
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
}
.dp__input {
    border: 1px solid $primary-stroke !important;
    border-radius: 8px !important;
    font-weight: 500;
    font-size: 14px;
    font-family: "HelveticaNeue";
}
.dp__disabled {
    background-color: #e9ecef !important;
    opacity: 1;
}
.dp__disabled:hover {
    border: 1px solid #ced4da !important;
}
.dp__select {
    color: $color-menu;
}
.dp__today {
    border: 1px solid $color-menu;
}
.dp__range_end, .dp__range_start, .dp__active_date {
    background: $color-menu;
}
.dp__theme_light {
    --dp-text-color: black;
    --dp-common-transition: opacity 2s ease-in;
}
</style>
